import { LogEntriesListCombinedProps } from './types';

const usePresenter = (props: LogEntriesListCombinedProps): LogEntriesListCombinedProps => {
  return props;
};

export default usePresenter;
